import { render, staticRenderFns } from "./Jokes.vue?vue&type=template&id=83185830&scoped=true"
import script from "./Jokes.vue?vue&type=script&lang=js"
export * from "./Jokes.vue?vue&type=script&lang=js"
import style0 from "./Jokes.vue?vue&type=style&index=0&id=83185830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83185830",
  null
  
)

export default component.exports